<span class="cursor-pointer link" style="font-size: 0.9rem;" (click)="click($event)"><ng-content></ng-content></span>
